import React from 'react';
import { getHourlyLabel, ServiceTypes } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { ChipType, toWeekdayWeekendFormat } from '../../../helpers/Constants';
import HourlyRateChipLabel from './HourlyRateChipLabel';
import CustomChip from '../CustomChip';
import strings from '../../../localization';
import styles from './styles';

interface IAdminLongTermUserRates {
  contractStartDate?: string;
  pharmacyWeekDayHourlyRate?: number;
  pharmacyWeekendHourlyRate?: number;
  weekDayHourlyRate?: number;
  weekendHourlyRate?: number;
  successAction: string;
}

const AdminLongTermUserRates = ({
  pharmacyWeekDayHourlyRate,
  pharmacyWeekendHourlyRate,
  weekDayHourlyRate,
  weekendHourlyRate,
  contractStartDate,
  successAction,
}: IAdminLongTermUserRates) => {
  const isSelfService = ServiceHandler.getService() === ServiceTypes.self;
  const showPharmacyLongTermLabel = !isSelfService && contractStartDate;
  const pharmacyLabel = toWeekdayWeekendFormat(
    pharmacyWeekDayHourlyRate,
    pharmacyWeekendHourlyRate,
  );
  const label = toWeekdayWeekendFormat(weekDayHourlyRate, weekendHourlyRate);

  return {
    customPharmacyChip: showPharmacyLongTermLabel ? (
      <HourlyRateChipLabel
        customContainerStyle={styles.chipContainer}
        label={`${strings.pharmacyHourlyRate} ${getHourlyLabel(
          pharmacyWeekDayHourlyRate,
          pharmacyWeekendHourlyRate,
        )}`}
        customChip={
          <CustomChip label={pharmacyLabel} type={ChipType.hourlyRate} />
        }
        type={ChipType.hourlyRate}
        successAction={successAction}
      />
    ) : null,
    customPharmacistChip: contractStartDate ? (
      <HourlyRateChipLabel
        customContainerStyle={styles.chipContainer}
        label={`${strings.pharmacistHourlyRate} ${getHourlyLabel(
          weekDayHourlyRate,
          weekendHourlyRate,
        )}`}
        customChip={<CustomChip label={label} type={ChipType.hourlyRate} />}
        type={ChipType.hourlyRate}
        successAction={successAction}
      />
    ) : null,
  };
};

export default AdminLongTermUserRates;
